/* Dulora collection page — closes the facet popover dropdowns on outside
   click (≥1024px the sidebar is converted into a horizontal row of popovers
   by dulora-collection.css; the theme's DetailsDisclosure only toggles on
   summary clicks and would leave panels stuck open).
   Uses event delegation so it survives facet AJAX re-renders and Theme
   Editor section reloads.
   NOTE: close via the details-disclosure element's close() method, never
   summary.click() — a synthetic click bubbles back into this handler and,
   because DetailsDisclosure keeps [open] until its transition ends, two
   closing panels re-close each other in an unbounded cascade (page freeze). */
if (!window.duloraCollectionFiltersInit) {
  window.duloraCollectionFiltersInit = true;

  const closeFilter = (details) => {
    if (details.classList.contains('is-closing')) return; // already animating shut
    const disclosure = details.closest('details-disclosure');
    if (disclosure && typeof disclosure.close === 'function') {
      disclosure.close(); // reuse the theme's close animation
    } else {
      details.open = false;
    }
  };

  document.addEventListener('click', (evt) => {
    if (!evt.isTrusted) return; // ignore programmatic clicks
    if (!window.matchMedia('(min-width: 1024px)').matches) return;

    document.querySelectorAll('.facets__filters details.filter[open]').forEach((details) => {
      if (details.contains(evt.target)) return; // click inside this dropdown
      closeFilter(details);
    });
  });

  document.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Escape') return;
    document.querySelectorAll('.facets__filters details.filter[open]').forEach(closeFilter);
  });
}
